import { useState } from 'react';
import { Link } from 'react-router-dom';

/* ── Sections ── */
import HeroSection from './partner/HeroSection';
import StatsBar from './partner/StatsBar';
import ServicesGrid from './partner/ServicesGrid';
import ProcessSteps from './partner/ProcessSteps';
import WhyUsSection from './partner/WhyUsSection';
import ServiceAreas from './partner/ServiceAreas';
import QuoteForm from './partner/QuoteForm';
import TestimonialsSection from './partner/TestimonialsSection';
import FAQSection from './partner/FAQSection';
import PartnerFooter from './partner/PartnerFooter';
import StickyCTA from './partner/StickyCTA';

export default function PartnerLandingPage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white text-ink-900 font-sans antialiased overflow-x-hidden">
      {/* ── Navbar ── */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-gray-100 transition-all duration-300">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16 sm:h-20">
            <a href="#" className="text-lg sm:text-xl font-bold tracking-tight text-ink-900 whitespace-nowrap">
              PVC Vloer Nederland
            </a>

            {/* Desktop Nav */}
            <div className="hidden lg:flex items-center gap-8">
              <a href="#services" className="text-sm font-medium text-ink-700 hover:text-brass-600 transition-colors whitespace-nowrap">Diensten</a>
              <a href="#proces" className="text-sm font-medium text-ink-700 hover:text-brass-600 transition-colors whitespace-nowrap">Proces</a>
              <a href="#offerte" className="text-sm font-medium text-ink-700 hover:text-brass-600 transition-colors whitespace-nowrap">Offerte</a>
              <a href="#faq" className="text-sm font-medium text-ink-700 hover:text-brass-600 transition-colors whitespace-nowrap">FAQ</a>
              <a
                href="#offerte"
                className="inline-flex items-center gap-2 bg-brass-500 hover:bg-brass-600 text-white px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap"
              >
                Gratis Offerte
              </a>
            </div>

            {/* Mobile hamburger */}
            <button
              className="lg:hidden p-2 text-ink-900"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="Menu"
            >
              <i className={`ri-${mobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden bg-white border-t border-gray-100 px-4 py-4 space-y-3">
            <a href="#services" onClick={() => setMobileMenuOpen(false)} className="block text-sm font-medium text-ink-700 py-2">Diensten</a>
            <a href="#proces" onClick={() => setMobileMenuOpen(false)} className="block text-sm font-medium text-ink-700 py-2">Proces</a>
            <a href="#offerte" onClick={() => setMobileMenuOpen(false)} className="block text-sm font-medium text-ink-700 py-2">Offerte</a>
            <a href="#faq" onClick={() => setMobileMenuOpen(false)} className="block text-sm font-medium text-ink-700 py-2">FAQ</a>
            <a
              href="#offerte"
              onClick={() => setMobileMenuOpen(false)}
              className="block text-center bg-brass-500 text-white px-5 py-2.5 rounded-full text-sm font-medium"
            >
              Gratis Offerte
            </a>
          </div>
        )}
      </nav>

      {/* ── Sections ── */}
      <HeroSection />
      <StatsBar />
      <ServicesGrid />
      <ProcessSteps />
      <WhyUsSection />
      <ServiceAreas />
      <QuoteForm />
      <TestimonialsSection />
      <FAQSection />
      <PartnerFooter />
      <StickyCTA />
    </div>
  );
}